import React, { useState, useEffect } from "react";
import { znajdzNajblizszaStawke } from '../../../functions/stawki.js'
import { znajdzAktualny } from "../../../functions/stawki.js";
import Loader from "../../Loader.js";
import WspolnotaRozliczenieButtons from "./WspolnotaRozliczenieButtons.js";
import WspolnotaRozliczenieTable from "./WspolnotaRozliczenieTable.js";
import WspolnotaRozliczenieSaldo from './WspolnotaRozliczenieSaldo.js';
import RozliczenieWydrukModal from './Wydruk/RozliczenieWydrukModal.js';
import MieszkaniecWydruk from "../../Mieszkaniec/Wydruk/MieszkaniecWydruk.js";
import { dataFormatMsc, rrrr_mm_dd_to_mm_rrrr } from "../../../functions/dataFormat.js";
 
const WspolnotaRozliczenieDane = props => {

  const { idw, wspolnota, mieszkancy, lokale, ulice, grupy, udzialyKontaAkt, stawki, stawkiJednorazowe, stawkiJednorazoweInd, czynszeMsc, 
    czynszeWspolnota, przelewyWspolnota, miesiac, setMiesiac, listaMsc, ind, rozliczenieWody, wybraneRozliczenieWody } = props;

  const [showPrint, setShowPrint] = useState(false)
  const [stawkiAkt, setStawkiAkt] = useState(undefined);
  const [loaderOn, setLoaderOn] = useState(false);

  const [rozliczeniaMieszkancow, setRozliczeniaMieszkancow] = useState(false);

  const [udzialyKonta_a, setUdzialyKonta_a] = useState([]);
  const [grupy_a, setGrupy_a] = useState([]);
  const [stawkiOst, setStawkiOst] = useState([]);
  const [mieszkaniec, setMieszkaniec] = useState(undefined);
  const [grupa_numer, setGrupa_numer] = useState(undefined);
  const [tablicaCzynszeAkt, setTablicaCzynszeAkt] = useState([]);
  const [stawkiJednorazoweInd_u, setStawkiJednorazoweInd_u] = useState([]);
 
  const zestaw = (id_user, grupa_numer) => {
    setUdzialyKonta_a( udzialyKontaAkt?.find(u => u.id_wspolnoty == idw && u.id_user == id_user && u.grupa_numer == grupa_numer) );
    setGrupy_a( grupy?.filter( g => g?.id_user == id_user && g?.grupa_numer == grupa_numer) );
    setMieszkaniec( mieszkancy?.find( m => m?.id_user == id_user));
    setGrupa_numer(grupa_numer);
    console.log(stawkiJednorazoweInd)
    setStawkiJednorazoweInd_u( stawkiJednorazoweInd?.filter( s => s?.id_user == id_user && s?.grupa_numer == grupa_numer  && dataFormatMsc(s?.msc) == miesiac) )
    const czynsz1 = czynszeWspolnota?.find( c => c?.id_user == id_user).grupy_udzial_msc;
    const czynsz2 = czynsz1?.find( c => c?.grupa_numer == grupa_numer).temp_msc;
    setTablicaCzynszeAkt(czynsz2?.find( c => c?.msc == miesiac));
    
    handleShowPrintMieszkaniec();
  }

  useEffect( () => setStawkiOst(znajdzAktualny(stawki, miesiac)), [miesiac, stawki]);
  useEffect( () => setStawkiAkt( znajdzNajblizszaStawke(miesiac, stawki) ), [miesiac, stawki]);
  useEffect( () => czynszeWspolnota && przelewyWspolnota && czynszeMsc && ind ? setLoaderOn(false) : setLoaderOn(true), [czynszeWspolnota, przelewyWspolnota, czynszeMsc, ind]);

  const handleShowPrint = () => setShowPrint( prevState => !prevState);
  const handleShowPrintMieszkaniec = () => setRozliczeniaMieszkancow( prevState => !prevState);

  return (
    <div className="dane">
      <div className="left">
        <WspolnotaRozliczenieButtons
          miesiac={miesiac}
          setMiesiac={setMiesiac}
          listaMsc={listaMsc}
          handleShowPrint={handleShowPrint}
        />
        <WspolnotaRozliczenieTable
          stawki={stawkiAkt}
          stawkiJednorazowe={stawkiJednorazowe}
          czynszeMsc={czynszeMsc}
          ind={ind}
          idw={idw}
          wspolnota={wspolnota}
          lokale={lokale}
          ulice={ulice}
          grupy={grupy}
          udzialyKontaAkt={udzialyKontaAkt}
          przelewyWspolnota={przelewyWspolnota}
          czynszeWspolnota={czynszeWspolnota}
          mieszkancy={mieszkancy}
          zestaw={zestaw}
          wybraneRozliczenieWody={wybraneRozliczenieWody}
        />
      </div>
      
      <WspolnotaRozliczenieSaldo 
        listaMsc={listaMsc} 
        przelewyWspolnota={przelewyWspolnota} 
        czynsze={czynszeWspolnota} 
        miesiac={miesiac}
        setMiesiac={setMiesiac}
        rozliczenieWody={rozliczenieWody}
        wybraneRozliczenieWody={wybraneRozliczenieWody}
      />
      {
        rozliczeniaMieszkancow && (
          <MieszkaniecWydruk 
            udzialyKonta_a={udzialyKonta_a}
            showPrint={handleShowPrintMieszkaniec}
            mieszkaniec={mieszkaniec}
            tablicaCzynszeAkt={tablicaCzynszeAkt}
            stawkiOst={stawkiOst}
            stawkiJednorazowe={stawkiJednorazowe}
            stawkiJednorazoweInd={stawkiJednorazoweInd_u}
            lokale={lokale}
            ulice={ulice}
            grupy_a={grupy_a}
            miesiac={miesiac}
            grupa_numer={grupa_numer}
            wybraneRozliczenieWody={wybraneRozliczenieWody}
          />
        )
      }
      {
        showPrint && 
        <RozliczenieWydrukModal 
          showPrint={showPrint}
          handleShowPrint={handleShowPrint}
          wspolnota={wspolnota}
          miesiac={miesiac}
          stawki_w={stawkiAkt}
          stawkiJednorazowe={stawkiJednorazowe}
          czynszeMsc={czynszeMsc}
          idw={idw}
          lokale={lokale}
          ulice={ulice}
          grupy={grupy}
          udzialyKontaAkt={udzialyKontaAkt}
          przelewyWspolnota={przelewyWspolnota}
          czynszeWspolnota={czynszeWspolnota}
          mieszkancy={mieszkancy}
          ind={ind}
          wybraneRozliczenieWody={wybraneRozliczenieWody}
        />
      } 
      <Loader stan={loaderOn} />
    </div>
  )
}

export default WspolnotaRozliczenieDane;